import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { msalConfig } from "./config";
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { ReactFlowProvider } from "reactflow";

if (process.env.NODE_ENV !== "development") {
  window.console.log = function () {};
  window.console.error = () => {};
  window.console.debug = () => {};
}
window.REACT_APP_VERSION = process.env.REACT_APP_VERSION;

export const msalInstance =
    await PublicClientApplication.createPublicClientApplication(msalConfig);

if (!msalInstance.getActiveAccount()) {
  // Just default to the first account if there are multiple
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }
}

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload?.account) {
    const account = event.payload.account;
    msalInstance.setActiveAccount(account);
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <ReactFlowProvider>
      <App pca={msalInstance} />
    </ReactFlowProvider>
  </BrowserRouter>
);
